import React from 'react';
import { Typography, Box } from '@mui/material';

interface TitleProps {
  title: string;
  color?: 'blue' | 'green';
}

const Title: React.FC<TitleProps> = ({ title, color = 'blue' }) => (
  <Box sx={{ mb: 3, pb: 2.5, borderBottom: 1, borderColor: 'divider' }}>
    <Typography
      variant="h5"
      component="h1"
      sx={{ color: color === 'green' ? 'success.dark' : 'text.primary', fontSize: { xs: '1.375rem', sm: '1.75rem' } }}
    >
      {title}
    </Typography>
  </Box>
);

export default Title;
